<template>
  <div>
    <a-card title="用户列表">
      <div class="left">
        <a-tree
          v-if="departList.length>0"
          @select="handleChange"
          :default-expanded-keys="expandedKeys"
        >
          <a-tree-node v-for="item in departList" :title="item.name" :key="item.id">
            <a-tree-node v-for="items in item.children" :title="items.name" :key="items.id" />
          </a-tree-node>
        </a-tree>
      </div>
      <div class="right"> <div class="select-box">
        <a-row type="flex" justify="start" style="padding:0 0 20px 0">
          <!--          <a-col :span="8">-->
          <!--            <a-tree-select-->
          <!--              style="width: 300px"-->
          <!--              v-model="selectValue"-->
          <!--              placeholder="请选择部门"-->
          <!--              allowClear-->
          <!--              treeDefaultExpandAll-->
          <!--              @change="handleChange"-->
          <!--            >-->
          <!--              <a-tree-select-node :value="&quot;parent-&quot; + items.id" :title="items.name" v-for="(items,index) in departList" :key="index">-->
          <!--                <a-tree-select-node :value="&quot;parent-&quot; + v.id" :title="v.name" :key="index" v-for="(v,index) in items.children">-->
          <!--                </a-tree-select-node>-->
          <!--              </a-tree-select-node>-->
          <!--            </a-tree-select>-->
          <a-col :span="6" :offset="1">
            <a-input-search
              @search="onSearch"
              enterButton
              v-model="value"
              placeholder="请输入查找姓名"
            />
          </a-col>
        </a-row>
        <a-row type="flex" justify="start" style="padding:0 0 20px 0">
          <a-col :span="23" :offset="1">
            <a-table
              :columns="columns"
              :dataSource="data"
              rowKey="id"
              :loading="loading"
              :pagination="pagination"
              @change="handleTableChange">
              <!-- 注：用户状态为停用，不显示操作的系列按钮 -->
              <div slot="status" slot-scope="text,info">
                <a-tag color="green" v-if="info.status == 1">正常</a-tag>
                <a-tag color="red" v-else>停用</a-tag>
              </div>
              <div slot="action" slot-scope="text,record">
                <a-button type="primary" @click="showEditForm(record)" class="edit-style">权限设置</a-button>
                <a-button @click="discontinueUse(record)" v-if="record.status == 1">停用</a-button>
                <a-button @click="discontinueUse(record)" v-else>启用</a-button>&nbsp;&nbsp;
                <a-button type="danger" @click="showDeleteModal(record)">删除</a-button>
              </div>
            </a-table>
          </a-col>
        </a-row>
      </div>
      </div>
    </a-card>
    <a-modal
      title="选择角色"
      v-model="editVisibleModal"
      width="800px"
      @ok="editHandleOk"
    >
      <a-form :form="form">
        <a-form-item :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-radio-group v-for="item in roleList" :key="item.id" @change="onChangeDepartment" v-decorator="['role_id']">
            <a-radio :value="item.id" >{{ item.name }}</a-radio>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { frontUserList, delFrontUserList, statusFrontUser, getDepartmentalList, userSeleRole, getRoleList } from '@/api/manage'
import pick from 'lodash.pick'
const columns = [{
  title: 'ID',
  dataIndex: 'id',
  key: 'id'
}, {
  title: '姓名',
  dataIndex: 'name',
  key: 'name'
}, {
  title: '状态',
  key: 'status',
  dataIndex: 'status',
  scopedSlots: { customRender: 'status' }
}, {
  title: '角色',
  key: 'role_name',
  dataIndex: 'role_name'
}, {
  title: '操作',
  key: 'action',
  scopedSlots: { customRender: 'action' }
}]

export default {
  data () {
    return {
      expandedKeys:[],
      data: [],
      departList: [],
      roleList: [],
      columns,
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1
      },
      form: this.$form.createForm(this),
      staffName: '',
      roleValue: '',
      staffId: '',
      selectValue: '',
      departValue: [],
      // 编辑modal
      editVisibleModal: false,
      loading: false,
      value: '',
      departId: 1,
      roleList: [],
      roleId: '',
      selectRoleId: '' // 选择的id
    }
  },
  mounted () {
    this.departmentListInit()
    // this.getRoleListInit()
    this.getFrontUserListInit(1, this.departId)
  },
  methods: {
    // 下拉框操作
    handleChange (e) {
      this.value = ''
      this.departId = e[0]
      this.getFrontUserListInit(1, this.departId)
    },
    // 搜索操作获取value
    onSearch (value) {
      this.getFrontUserListInit(1, this.departId)
    },
    // 停用的按钮操作
    discontinueUse (e) {
      if (e.status === 0) {
        e.status = 1
      } else {
        e.status = 0
      }
      return statusFrontUser({
        frontUserId: e.id,
        status: e.status
      })
        .then(res => {
          this.$message.success(res.msg)
          this.getFrontUserListInit(this.pagination.current, this.departId)
        })
        .catch(err => this.requestFailed(err))
        .finally(() => {
        })
    },
    // 编辑按钮modal控制操作
    showEditForm (e) {
      this.editVisibleModal = true
      this.roleId = e.id
      return getRoleList({
        status: 2
      }).then(res => {
        this.roleList = res.result
        new Promise(resolve => {
          resolve()
        }).then(() => {
          const formData = pick(e, ['role_id'])
          this.form.setFieldsValue(formData)
        })
      }).catch(err => this.requestFailed(err))
        .finally(() => {
        })
    },
    // 编辑用户
    editHandleOk (e) {
      return userSeleRole({
        roleId: this.selectRoleId,
        userId: this.roleId
      }).then(res => {
        this.$message.success(res.msg)
        this.editVisibleModal = false
        this.value = ''
        this.getFrontUserListInit(this.pagination.current, this.departId)
      }).catch(err => this.failed(err))
        .finally(() => {

        })
    },
    // 编辑内部门选择
    onChangeDepartment (e) {
      this.selectRoleId = e.target.value
    },
    failed (err) {
      this.$notification['error']({
        message: '错误',
        description: ((err.response || {}).data || {}).msg || '请求出现错误，请稍后再试',
        duration: 4
      })
    },
    // 获取接口错误提示
    requestFailed (err) {
      console.log(err)
      // this.$notification['error']({
      //   message: '错误',
      //   description: ((err.response || {}).data || {}).msg || '请求出现错误，请稍后再试',
      //   duration: 4
      // })
    },
    // 删除的按钮操作
    showDeleteModal (e) {
      this.$confirm({
        title: '是否删除当前用户?',
        content: '删除后将不可恢复',
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          return delFrontUserList({
            frontUserId: e.id
          }).then(res => {
            console.log(res)
            this.$message.success(res.msg)
            this.getFrontUserListInit(this.pagination.current, this.departId)
          }).catch(err => this.requestFailed(err))
            .finally(() => {
            })
        },
        onCancel () {
          console.log('Cancel')
        }
      })
    },
    // 获取用户列表
    getFrontUserListInit (page, id) {
      this.loading = true
      return frontUserList({
        page: page,
        pageSize: 10,
        departmentId: id,
        name: this.value
      })
        .then(res => {
          this.loading = false
          this.data = res.result.list
          this.pagination.total = res.result.total
        })
        .catch(err => this.requestFailed(err))
        .finally(() => {
          this.loading = false
        })
    },
    // 获取部门
    departmentListInit () {
      return getDepartmentalList()
        .then(res => {
          res.result.forEach((item) => {
            item.name = item.name + ' (' + item.employee_num + '人)'
            if (item.children) {
              item.children.forEach((itemChild) => {
                itemChild.name = '|— ' + itemChild.name + ' (' + itemChild.employee_num + '人)'
              })
            }
          })
          this.departList = res.result
          this.expandedKeys.push(this.departList[this.departList.length-1].id)
        })
        .catch(err => this.requestFailed(err))
        .finally(() => {
        })
    },
    // 选择内部员工和外部员工
    onChangestaffName (e) {
      console.log(e.target.value)
    },
    // 获取角色列表
    // getRoleListInit () {
    //   return getFrontRoleList({
    //     status: 2
    //   })
    //     .then(res => {
    //       this.roleList = res.result
    //     })
    //     .catch(err => this.requestFailed(err))
    //     .finally(() => {
    //     })
    // },
    handleTableChange (pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.getFrontUserListInit(this.pagination.current, this.departId)
    }
  }
}
</script>

<style>
  .left {
    display: inline-block;
    width: 15%;
    height: 100%;
    vertical-align: top;
    /*border-right: 1px solid #cccccc;*/
  }
  .right {
    display: inline-block;
    vertical-align: top;
    width: 84%;
    text-align: right;
    border-left: 1px solid #cccccc;
  }
.edit-style {
  margin: 0 10px;
}
.role-container {
  margin-top: 10px;
}
.main-text,.department {
  font-weight: bold;
}
/*.department {*/
/*  margin-top: 10px;*/
/*}*/
.department-list {
  display: inline-block;
  width: 140px;
  margin-top: 10px;
  /*padding-left: 20px;*/
}
.department-list .department-title{
  vertical-align: top;
  margin-top: -6px;
}
</style>
